import React from 'react';
import { TruckIcon } from 'lucide-react';
import { IMAGES } from '../data/site';
import { CATALOG, lowestPrice } from '../data/catalog';
import { MAIN_WHATSAPP_MESSAGE } from '../data/messages';
import { formatMXN } from '../utils/currency';
import { WhatsAppButton } from './WhatsAppButton';
import { PerksStrip } from './PerksStrip';
export function Hero() {
  return <section className="bg-navy-900 text-white" data-id="element-66" data-mp="4jvwndf77cxb">
      <div className="mx-auto grid max-w-content grid-cols-1 gap-8 px-4 pb-8 pt-7 sm:px-6 sm:pb-14 sm:pt-12 lg:grid-cols-[minmax(0,1.1fr)_minmax(0,0.9fr)] lg:items-center lg:gap-12" data-id="element-67" data-mp="128frrovbsnyc">
        <div data-id="element-68" data-mp="sai535t46z7u">
          <p className="mb-3 flex items-center gap-2.5 text-xs font-semibold uppercase tracking-[0.16em] text-accent-500" data-id="element-69" data-mp="sa9nj0m1r5qb">
            <span className="guide-line h-px w-6" aria-hidden="true" data-id="element-70" data-mp="nbyh6zuyndcu" />
            Bovedilla · Casetón · Vigueta
          </p>

          <h1 className="text-balance font-display text-[1.95rem] font-bold leading-[1.04] sm:text-5xl lg:text-[3.4rem]" data-id="element-71" data-mp="382ff5o82r4ex">
            Bovedilla EPS, Casetón y Vigueta en el Bajío.{' '}
            <span className="text-accent-500" data-id="element-72" data-mp="3j6g1bysfzti2">Precios de fábrica.</span>
          </h1>

          <p className="mt-3 max-w-xl text-[15px] leading-relaxed text-steel-200 sm:mt-5 sm:text-lg" data-id="element-73" data-mp="3o6u5v6uu4lbc">
            Bovedilla EPS desde <strong className="text-white" data-id="element-74" data-mp="3e9frrdwdw8m7">$300</strong> (12 cm) y vigueta desde{' '}
            <strong className="text-white" data-id="element-75" data-mp="3ebir4ojffe3l">$110</strong>. Entrega en Querétaro, León, Celaya y todo el Bajío.
          </p>
          <p className="mt-2 max-w-xl text-sm text-steel-400" data-id="element-76" data-mp="358rfooqjwiby">
            Para constructoras, arquitectos, contratistas y distribuidores.
          </p>

          <div className="mt-5 flex flex-col gap-2.5 sm:mt-7 sm:flex-row" data-id="element-77" data-mp="2qleq8oxmhsga">
            <WhatsAppButton message={MAIN_WHATSAPP_MESSAGE} label="Cotizar por WhatsApp" location="hero" size="lg" className="shadow-lg shadow-black/30" data-id="element-78" data-mp="2vjzpom51w83o" />
            <a href="#cotizador" className="inline-flex items-center justify-center whitespace-nowrap rounded-md border border-white/25 px-7 py-4 text-base font-semibold text-white transition-colors duration-150 ease-out hover:border-white hover:bg-white/10 sm:text-lg" data-id="element-79" data-mp="2ljz6d076lrzh">
              Armar mi pedido
            </a>
          </div>
          <p className="mt-2.5 text-xs text-steel-400 sm:text-sm" data-id="element-80" data-mp="degeefp1uar0">
            Respuesta rápida · Facturamos · Entrega sin costo desde $5,000
          </p>

          <dl className="mt-6 grid grid-cols-3 gap-px overflow-hidden rounded-lg bg-white/10" data-id="element-81" data-mp="1622hlmud7ddc">
            {CATALOG.map(cat => <div key={cat.id} className="bg-navy-800 px-2.5 py-2.5 sm:px-4 sm:py-3" data-id="element-82" data-mp="111omt6hrxzx9">
                <dt className="text-xs text-steel-400 sm:text-sm" data-id="element-83" data-mp="x1w6g7m52phc">{cat.shortLabel} desde</dt>
                <dd className="font-display text-2xl font-semibold leading-tight text-white" data-id="element-84" data-mp="3ltgojuoc2yqg">
                  {formatMXN(lowestPrice(cat))}
                </dd>
              </div>)}
          </dl>
        </div>

        <figure className="relative" data-id="element-85" data-mp="1xam5iqqvrqyx">
          <img src={IMAGES.hero} alt="Colaborador de OA LOSAS sonriendo frente a bovedilla EPS en existencia" className="aspect-[16/10] w-full rounded-xl object-cover object-[50%_32%] shadow-2xl shadow-black/40 sm:aspect-[16/9] lg:aspect-[4/5] lg:object-center" loading="eager" fetchPriority="high" data-id="element-86" data-mp="1x7hwng2h071x" />
          <figcaption className="absolute bottom-3 left-3 right-3 flex items-center gap-2.5 rounded-lg bg-white/95 px-3 py-2.5 text-navy-900 shadow-lg sm:bottom-4 sm:left-4 sm:right-auto sm:px-4" data-id="element-87" data-mp="2fzam50ibza4w">
            <TruckIcon className="h-5 w-5 shrink-0 text-accent-500" aria-hidden="true" data-id="element-88" data-mp="2p10dy7g4kb37" />
            <span className="text-sm leading-tight" data-id="element-89" data-mp="2tyaf2kcvmb6v">
              <strong className="block font-semibold" data-id="element-90" data-mp="umppw17ctkyh">Entrega sin costo</strong>
              en pedidos desde $5,000
            </span>
          </figcaption>
        </figure>
      </div>

      <div className="mx-auto max-w-content px-4 pb-6 sm:px-6 sm:pb-12" data-id="element-91" data-mp="zndphb9nfa4b">
        <PerksStrip data-id="element-92" data-mp="49jca2mu6jl2" />
      </div>
    </section>;
}